module.exports = __webpack_public_path__ + "img/coat_5.70a7792c.png";